export default class RoutingInfo {
  constructor(modal, route, params) {
    this.modal = modal;
    this.route = route;
    this.params = params;
  }
}
